// extracted by mini-css-extract-plugin
export default {"statusCell":"iq8y36s7jM39ysDMonOF","cancelledStatus":"zCfvXJP4xgmCaJDsyEZb","cancelledStatusDescription":"roK3yk9Nx3LdrarHE2LQ"};